<template>
  <img
    :src="dataURL"
    :data-src="fixedSize ? $image(media.src, fixedSize) : $image(media.src)"
    :data-srcset="fixedSize ? '' : srcset"
    data-sizes="auto"
    class="lazyload vimg"
    :class="customClass"
    :alt="media.alt || $attrs.alt || 'Image'"
    @lazyloaded="$emit('loaded')"
  />
</template>

<script>
export default {
  name: 'VImg',

  props: [ 'media', 'fixedSize', 'customClass' ],

  computed: {
    srcset () {
      if (this.fixedSize) return null

      let srcset = this.$image(this.media.src, '200x') + ' 100w'

      this.media.width >= 200 ? srcset += `, ${ this.$image(this.media.src, '400x') } 200w` : ''
      this.media.width >= 400 ? srcset += `, ${ this.$image(this.media.src, '800x') } 400w` : ''
      this.media.width >= 600 ? srcset += `, ${ this.$image(this.media.src, '1200x') } 600w` : ''
      this.media.width >= 800 ? srcset += `, ${ this.$image(this.media.src, '1600x') } 800w` : ''
      this.media.width >= 1000 ? srcset += `, ${ this.$image(this.media.src, '2000x') } 1000w` : ''
      this.media.width >= 1500 ? srcset += `, ${ this.$image(this.media.src, '3000x') } 1500w` : ''
      this.media.width >= 2000 ? srcset += `, ${ this.$image(this.media.src, '4000x') } 2000w` : ''

      return srcset
    },

    // This will stop content reflow issue by supplying src attr with image aspect as a canvas
    dataURL () {
      const width = this.media.width
      const height = this.media.height
      if (!width || !height) return ''

      const w = 100
      const canvas = document.createElement('canvas')
      canvas.width = w
      canvas.height = (height / width) * w

      return canvas.toDataURL()
    }
  }
}
</script>
